import { Component } from "react";

// Red de seguridad: si algún componente lanza un error de render inesperado, mostramos
// un mensaje claro con botón de recarga en vez de dejar una pantalla en blanco sin
// ninguna pista de qué ha pasado.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary capturó un error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white px-4" data-testid="error-boundary-screen">
          <div className="text-center max-w-md">
            <h1 className="font-heading font-bold text-xl text-municipal mb-2">Algo ha ido mal</h1>
            <p className="text-gray-500 mb-6">
              Ha ocurrido un error inesperado. Recarga la página para volver a intentarlo.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-municipal hover:bg-municipal-dark text-white font-semibold px-5 py-2.5 rounded-xl"
              data-testid="error-boundary-reload-btn"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
